import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from 'next/link';
import { useState } from 'react';
import AddDomainWizard from './Settings/AddDomainWizard';
import { useSnackbar } from 'notistack';

export default function BlogChecklist(props) {
  const [openAddDomainWizard, setOpenAddDomainWizard] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const { setTab, plan } = props;
  const checklist = [
    {
      title: 'Customize your site',
      action: 'Open site builder',
      externalLink: `https://${props.blogId}.truvvl.blog/api/edit?editKey=${props.blog.editKey}`,
    },
    {
      title: 'Pick a plan',
      action: 'Pick now',
      isComplete: props.plan !== 'trial',
      tab: 4,
    },
    {
      title: 'Add a description',
      action: 'Add now',
      isComplete: props.blogSlogan,
      tab: 2,
    },
    { title: 'Add a logo', action: 'Add now', isComplete: props.logo, tab: 2 },
    {
      title: 'Add a small logo',
      action: 'Add now',
      isComplete: props.squareLogo,
      tab: 2,
    },
    {
      title: 'Connect your own domain',
      action: 'Connect',
      isComplete: props.blog.domain,
      subscribedAction: () => {
        setOpenAddDomainWizard(true);
      },
      trialAction: () => {
        setTab(4);
        enqueueSnackbar('Custom domains are only available in our paid plans', {
          variant: 'info',
        });
      },
    },
  ];
  let checklistComplete = 0;
  checklist.forEach(({ isComplete }) => {
    if (isComplete) checklistComplete++;
  });

  return (
    <>
      <div className="tw-flex">
        <div className="tw-shrink-0">
          <Box position="relative" display="inline-flex">
            <CircularProgress
              variant="determinate"
              value={(checklistComplete / checklist.length) * 100}
              size={80}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                variant="caption"
                component="div"
                color="textSecondary"
                className="tw-text-2xl tw-tracking-tighter tw-font-semibold"
              >
                {checklistComplete} / {checklist.length}
              </Typography>
            </Box>
          </Box>
        </div>
        <div className="pl-3">
          <Typography variant="h6" color="textPrimary">
            Configure your blog
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Get creative with your travel blog and customize it to your
            heart&apos;s desire with our easy-to-use site builder! No coding
            skills needed, just drag and drop your way to a unique and
            personalized blog.
          </Typography>
        </div>
      </div>
      <List>
        {checklist.map(item => {
          const listItem = (
            <>
              <ListItemIcon>
                <Checkbox disabled checked={item.isComplete} />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                className={item.isComplete ? 'tw-line-through' : ''}
              />
              {!item.isComplete && (
                <Button variant="outlined" className="tw-hidden sm:tw-block">
                  {item.action}
                </Button>
              )}
            </>
          );
          if (item.tab && !item.isComplete)
            return (
              <ListItem
                key={item.title}
                button
                onClick={() => setTab(item.tab)}
              >
                {listItem}
              </ListItem>
            );
          if (item.externalLink && !item.isComplete)
            return (
              <a
                href={item.externalLink}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <ListItem key={item.title} button>
                  {listItem}
                </ListItem>
              </a>
            );

          if (item.trialAction && !item.isComplete && plan === 'trial')
            return (
              <a onClick={item.trialAction}>
                <ListItem key={item.title} button>
                  {listItem}
                </ListItem>
              </a>
            );
          if (item.subscribedAction)
            return (
              <a onClick={item.subscribedAction}>
                <ListItem key={item.title} button>
                  {listItem}
                </ListItem>
              </a>
            );
          if (item.internalLink && !item.isComplete)
            return (
              <Link href={item.internalLink}>
                <ListItem key={item.title} button>
                  {listItem}
                </ListItem>
              </Link>
            );
          return (
            <ListItem key={item.title} button className="tw-cursor-default">
              {listItem}
            </ListItem>
          );
        })}
      </List>
      <AddDomainWizard
        {...props}
        open={openAddDomainWizard}
        setOpen={setOpenAddDomainWizard}
      />
    </>
  );
}
